export default "__VITE_ASSET__ChnKmBrK__"